const uniqueId = prefix => {
  return `${prefix || ''}${Math.round(Math.random() * 1e16)}`
}

class TocEditor {
  constructor($root) {
    if (!$root.length) return
    this.$root = $root
    this.$list = $root.find('.toc-editor__list')

    Sortable.create(this.$list.get(0), {
      animation: 150,
      forceFallback: true,
      ghostClass: 'toc-editor__item--ghost',
      dragClass: 'toc-editor__item--drag',
      fallbackClass: 'toc-editor__item--drag',
      onStart: this.handleDragStart.bind(this),
      onEnd: this.handleDragEnd.bind(this),
    })

    $root.closest('form').on('submit', this.handleSubmit.bind(this))
    $root.on('click', '.toc-editor__rename', this.handleRename.bind(this))
    $root.on('click', '.toc-editor__delete', this.handleDelete.bind(this))
    $root.on('click', '.toc-editor__add', this.handleAddSection.bind(this))
  }

  handleDragStart(event) {
    this.$list.addClass('toc-editor__list--dragging')
  }

  handleDragEnd(event) {
    this.$list.removeClass('toc-editor__list--dragging')
  }

  handleAddSection() {
    const sectionName = prompt('Enter section name:')
    if (!sectionName) return

    $(`
      <div class='toc-editor__item' data-id='${uniqueId('section_')}' data-type='section'>
        <div class='toc-editor__title'>
          <div class='toc-editor__display-title'>${_.escape(sectionName)}</div>
        </div>
        <div class='toc-editor__actions'>
          <div class='toc-editor__delete'></div>
          <div class='toc-editor__rename'></div>
        </div>
      </div>
    `).appendTo(this.$list)
  }

  handleRename(event) {
    const $item = $(event.target).closest('.toc-editor__item')
    const type = $item.data('type')

    const newName = (prompt(`Enter ${type} name:`) || '').trim()
    if (!newName) return

    $item.find('.toc-editor__display-title').text(newName)
  }

  handleDelete(event) {
    $(event.target).closest('.toc-editor__item').remove()
  }

  handleSubmit() {
    // Scan DOM elements and generate JSON object with following schema:
    // {
    //   contents: [
    //     {type: 'section', name: 'Name', id: '2'},
    //     {type: 'post', name: 'Name', id: '1'},
    //     ...
    //   ]
    // }
    const contents = this.$list
      .find('.toc-editor__item')
      .toArray()
      .map(item => {
        return {
          type: $(item).data('type'),
          id: $(item).data('id'),
          name: $(item).find('.toc-editor__display-title').text(),
        }
      })

    const $hiddenField = this.$root.find('.js-toc-settings')

    $hiddenField.val(JSON.stringify({ contents }))
  }
}

document.addEventListener('DOMContentLoaded', () => {
  return new TocEditor($('.toc-editor'))
})
